import { Box, Grid, HStack, Heading, Progress, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import cursor from '../../../assets/images/cursor.png'
import Slidebar from '../Slidebar'
import { RiArrowDownLine, RiArrowLeftUpLine } from 'react-icons/ri'
import LineChart, { DoughnutChart } from './Chart'
import { Doughnut } from 'react-chartjs-2'

const Databox=({title,qty,qtyPercentage,profit})=>(
    <Box w={['full','20%']} boxShadow={'-2px 0 10px rgba(107,70,193,0.5)'} p='8' borderRadius={'lg'}>
<Text children={title} />
<HStack spacing={'6'}>
    <Text fontSize={'2xl'} fontWeight='bold' children={qty} />
    <HStack>
    <Text children={`${qtyPercentage}%`}/>
    {profit?<RiArrowLeftUpLine color='green'/>:(
        <RiArrowDownLine color='red'/>
    )}
</HStack>
</HStack>

<Text opacity={0.6} children={"Since Last Month"} />
    </Box>
)
const Bar=({title,value,profit})=>(
    <Box py='4' px={['0','20']}>
<Heading size='sm' children={title} mb='2' />
<HStack w='full' alignItems={'center'}>
<Text children={profit?"0":`-${value}%`} />
<Progress w='full' value={profit? value:0} colorScheme='purple'/>
<Text children={`${value> 100?value:100}%`} />
</HStack>
    </Box>
)
const Dashboard = () => {
  return (
    <Grid minH={'100vh'} css={{cursor:`url(${cursor}),default`}} templateColumns={['1fr','5fr 1fr']}>
        <Box boxSizing='border-box' px={['4','0']} py='16' >
            <Text textAlign={'center'} opacity={0.5} children={`Last change was on ${String(new Date()).split('G')[0]}`}/>
<Heading children="Dashboard" ml={['0','16']} mb='16' textAlign={['center','left']}/>
<Stack direction={['column','row']} minH='24' justifyContent={'space-evenly'}>
<Databox title="Views" qty={123} qtyPercentage={30} profit={true} />
<Databox title="Users" qty={123} qtyPercentage={70} profit={true} />
<Databox title="Subscription" qty={23} qtyPercentage={30} profit={true} />
</Stack>

<Box m={['0','16']} borderRadius='lg' p={['0','16']} mt={['4','16']} boxShadow={'-2px 0 10px rgba(107,70,193,0.5)'}>
<Heading textAlign={['center','left']} size='md' children="Views Graph" pt={['8','0']} ml={['0','16']} />
{/*  Line Graph here*/}
<LineChart/>
</Box>
<Grid templateColumns={['1fr','2fr 1fr']} >
<Box p='4'>
<Heading textAlign={['center','left']} size='md' children="Progress Bar" my='8' ml={['0','16']} />
<Box>
    {/* Bar */}
    <Bar profit={true} title="Views" value={30} />
    <Bar profit={true} title="Users" value={78} />
    <Bar profit={false} title="Subscription" value={20} />
</Box>
</Box>

<Box p={['o','16']} boxSizing='border-box' py='4'>
<Heading textAlign={'center'} size='md' mb='4' children="Users" />
{/* Donut grapgh */}

<DoughnutChart/>
</Box>
</Grid>
        </Box>
        <Slidebar/>
    </Grid>
  )
}

export default Dashboard